export const initCurrencyData = {
  RUB: { symbol: "₽", text: "RUB" },
  UAH: { symbol: "₴", text: "UAH" },
  KZT: { symbol: "₸", text: "KZT" },
  USD: { symbol: "$", text: "USD" },
  EUR: { symbol: "€", text: "EUR" },
  BRL: { symbol: "R$", text: "BRL" },
  INR: { symbol: "₹", text: "INR" },
  CNY: { symbol: "¥", text: "CNY" },
};